import { useEffect } from 'react';

export const useHotjar = (appId: string) => {
    const hjid = "5254039";
    const hjsv = "6";
    const nblocksAppId = "606b3215efbe6b0008aee09d";
    const isEnabled = nblocksAppId === appId;

    useEffect(() => {
        if (!isEnabled || !hjid) return;

        // Check if Hotjar is already initialized
        if (document.querySelector(`script[src*="hotjar-${hjid}.js"]`)) {
            return; // Hotjar already exists, don't add it again
        }

        // Create and inject Hotjar script
        const script = document.createElement('script');
        script.async = true;
        script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${hjid},hjsv:${hjsv}};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
        document.head.appendChild(script);

        return () => {
            // Similar to GTM, we'll skip cleanup since we want Hotjar to persist
            // Removing it might cause issues with tracking
        };
    }, [hjid, hjsv, isEnabled]);
}; 